import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Header = ({ onOpenContact = () => {} }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDesktopMenuOpen, setIsDesktopMenuOpen] = useState(false);
  const desktopMenuRef = useRef(null);

  const navItems = [
    { label: 'Home', to: '/' },
    { label: 'Our Offers', to: '/our-offers' },
    { label: 'Our Magic Services', to: '/our-magic-services' },
    { label: 'Why Choose Us', to: '/why-choose-us' },
    { label: 'Service Area', to: '/service-area' },
    { label: 'Testimonials', to: '/testimonials' },
    { label: 'About Us', to: '/about-us' }
  ];

  const handleNavClick = () => {
    setIsMenuOpen(false);
    setIsDesktopMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (desktopMenuRef.current && !desktopMenuRef.current.contains(event.target)) {
        setIsDesktopMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="text-gray-600 body-font">
      <div className="container-fluid bg-gradient-to-r to-[#8ecb27] from-[#3f9422] px-3 py-2 md:px-5 md:py-4">
        <div className="flex items-center justify-between gap-2 md:flex-wrap md:justify-between">
          <Link to="/" className="flex min-w-0 flex-1 items-center text-gray-900 md:flex-none">
            <img src="/images/logo.png" className="h-9 w-9 rounded-full md:h-10 md:w-10" alt="Prime Lawn Logo" />
            <span className="ml-2 text-base font-bold leading-tight md:ml-3 md:text-xl">Prime Lawn & Snow Management</span>
          </Link>

          <div className="ml-auto flex items-center gap-3 md:gap-4">
            <div ref={desktopMenuRef} className="relative hidden md:block">
              <button
                type="button"
                onClick={() => setIsDesktopMenuOpen((prev) => !prev)}
                className="inline-flex items-center gap-2 rounded-lg bg-white/15 px-4 py-2 text-base font-semibold text-blue-900 shadow-sm transition hover:bg-white/25"
              >
                <span>Menu</span>
                <svg
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className={`h-4 w-4 transition-transform ${isDesktopMenuOpen ? 'rotate-180' : ''}`}
                >
                  <path d="M5.25 7.5 10 12.25 14.75 7.5H5.25Z" />
                </svg>
              </button>

              {isDesktopMenuOpen && (
                <div
                  className="absolute right-0 top-full z-20 mt-2 min-w-[220px] rounded-xl border border-green-200 bg-white p-2 shadow-xl"
                >
                  {navItems.map((item) => (
                    <Link
                      key={item.to}
                      to={item.to}
                      onClick={handleNavClick}
                      className="block rounded-lg px-3 py-2 text-left text-sm font-semibold text-blue-900 transition hover:bg-green-50 hover:text-[#2d7a1b]"
                    >
                      {item.label}
                    </Link>
                  ))}
                  <button
                    type="button"
                    onClick={() => {
                      onOpenContact();
                      handleNavClick();
                    }}
                    className="mt-1 block w-full rounded-lg px-3 py-2 text-left text-sm font-semibold text-blue-900 transition hover:bg-green-50 hover:text-[#2d7a1b]"
                  >
                    Contact Us
                  </button>
                </div>
              )}
            </div>

            <button
              type="button"
              onClick={() => setIsMenuOpen((prev) => !prev)}
              className="inline-flex items-center justify-center rounded-md border border-white/60 p-2 text-white md:hidden"
              aria-label="Toggle navigation menu"
              aria-expanded={isMenuOpen}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-6 w-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <nav className="mt-2 flex flex-col gap-2 rounded-xl bg-white/10 p-2 md:hidden">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={handleNavClick}
                className="rounded-md px-3 py-2 text-base font-semibold text-blue-900 hover:bg-white/20 hover:text-white"
              >
                {item.label}
              </Link>
            ))}
            <button
              type="button"
              onClick={() => {
                onOpenContact();
                setIsMenuOpen(false);
              }}
              className="rounded-md px-3 py-2 text-left text-base font-semibold text-blue-900 hover:bg-white/20 hover:text-white"
            >
              Contact Us
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;